import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DPO from 'dpo8core';
import { Formik, Form, Field } from 'formik';
import { LOGIN_FORM } from '@app/constants';
import LocalizedText from '@LocalizedText';
import useIntlMessage from '@app/hooks/use-intl-message';
import { inject } from '@app/providers/QAU.ContextProvider';
import classnames from 'classnames';

import { resetPassword } from '@app/actions/loginSignupActions';

import './ForgotPasswordForm.scss';

const ForgotPasswordForm = ({ selectLoginSignupStep, flowConfig }) => {
  const [accountError, setAccountError] = useState(false);
  const [emailPlaceholderText, invalidEmailError] = useIntlMessage('qau-email', 'qau-invalid-email-error');
  const goToLoginSignupFlow = () => selectLoginSignupStep(LOGIN_FORM);

  const validateEmail = email => {
    if (!email) return undefined;
    return DPO.project.Validator.email(email) && invalidEmailError;
  };

  const handleSubmit = values => {
    resetPassword(values, flowConfig)
      .then(({ request: { response } }) => {
        response === 'false' ? setAccountError(true) : goToLoginSignupFlow();
      })
      .catch(() => setAccountError(true));
  };

  return (
    <div id="forgot-password-form">
      <div className="password-reset-title">
        <LocalizedText id="qau-password-reset-title" />
      </div>
      {accountError && (
        <div className="account-error">
          <LocalizedText id="qau-password-reset-account-error" />
        </div>
      )}
      <div className="password-reset-text">
        <LocalizedText id="qau-password-reset-text" />
      </div>
      <Formik
        initialValues={{
          email: '',
        }}
        validateOnChange="true"
        onSubmit={handleSubmit}
      >
        {({ values, errors, touched }) => (
          <Form>
            <label>
              <Field
                type="email"
                name="email"
                id="reset-email"
                maxLength="100"
                placeholder={emailPlaceholderText}
                validate={validateEmail}
                className={classnames(
                  { invalid: errors.email && touched.email },
                  { valid: !errors.email && touched.email && values.email.length > 1 },
                )}
              />
              <span className="forgot-password-email-icons" />
              {errors.email && touched.email ? <div className="error-msg">{errors.email}</div> : null}
            </label>
            <div className="forgot-password-btns">
              <button className="submit-btn" type="submit">
                <LocalizedText id="qau-reset-btn" />
              </button>
              <button className="cancel-btn" onClick={goToLoginSignupFlow}>
                <LocalizedText id="qau-cancel-btn" />
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

ForgotPasswordForm.propTypes = {
  selectLoginSignupStep: PropTypes.func.isRequired,
  flowConfig: PropTypes.object.isRequired,
};

export default inject('flowConfig')(ForgotPasswordForm);
